
if (window.location.pathname === "/genieTrip") {
    let iter:number = +$('#numStops').text();
    for(let i:number = 0; i < iter; i++){
        let cont1:string = "#stopContainer1_" + i;
        let cont2:string = "#stopContainer2_" + i;
        let setHeightNum:number = $(cont1).height() + $(cont2).height() + 100;
        let setHeight:string = setHeightNum + "px"
        let setPic:string = "stopPic" + i;
        document.getElementById(setPic).style.height = setHeight;
    }
};
